import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const ArtboardIcon: React.FC<IStyledSVGIconProps> = (props) => {
  
  return (
    <StyledSVGIcon
      xmlns="http://www.w3.org/2000/svg" width="231" height="124" viewBox="0 0 231 124"
      {...props}
    >
        <defs>
        <clipPath id="clip-Artboard_1">
          <rect width="231" height="124"/>
        </clipPath>
      </defs>
      <g id="Artboard_1" data-name="Artboard – 1" clip-path="url(#clip-Artboard_1)" fill='none'>
        <rect width="231" height="124" fill="none"/>
        <g id="Component_24_2" data-name="Component 24 – 2" transform="translate(6.275 5.543)">
          <g id="Computer_Laptop" transform="translate(95.253)">
            <rect id="Rectangle_887" data-name="Rectangle 887" width="10.15" height="4.833" transform="translate(15.246 15.17) rotate(-45)"/>
            <rect id="Rectangle_888" data-name="Rectangle 888" width="27.309" height="4.833" transform="translate(15.124 27.352) rotate(-45)"/>
            <path id="Path_425" data-name="Path 425" d="M116.435,62.834V7.25c0-4.108-3.364-7.25-7.762-7.25H15.525c-4.4,0-7.762,3.142-7.762,7.25V62.834H0v2.417c0,6.767,5.692,12.084,12.937,12.084H111.26c7.245,0,12.937-5.317,12.937-12.084V62.834ZM12.937,7.25a2.368,2.368,0,0,1,2.587-2.417h93.148A2.368,2.368,0,0,1,111.26,7.25V62.834H74l-2.587,2.417H52.784L50.2,62.834H12.937ZM111.26,72.5H12.937a7.515,7.515,0,0,1-7.245-4.833H48.126l2.587,2.417H73.483l2.587-2.417H118.5A7.515,7.515,0,0,1,111.26,72.5Z"/>
          </g>
          <g id="Group_156920" data-name="Group 156920">
            <path id="Path_423" data-name="Path 423" d="M117.623,9H19.278A3.1,3.1,0,0,0,16,12.278V71.285a3.1,3.1,0,0,0,3.278,3.278h36.06V84.4H42.225v6.556h52.45V84.4H81.563V74.563h36.06a3.1,3.1,0,0,0,3.278-3.278V12.278A3.1,3.1,0,0,0,117.623,9ZM75.007,84.4H61.894V74.563H75.007Zm39.338-16.391H22.556V15.556h91.788Z" transform="translate(36.45 20.503)"/>
            <rect id="Rectangle_886" data-name="Rectangle 886" width="8.94" height="6.705" transform="translate(16.763 88.287)"/>
            <path id="Path_424" data-name="Path 424" d="M45.894,7.868,78.676,18.685v7.54h6.556v-7.54a6.7,6.7,0,0,0-4.589-6.228L43.6.328A1.2,1.2,0,0,0,42.616,0H6.556A6.576,6.576,0,0,0,0,6.556V104.9a6.576,6.576,0,0,0,6.556,6.556H72.119V104.9H45.894ZM6.556,6.556H39.338V104.9H6.556Z"/>
            <g id="Rectangle_889" data-name="Rectangle 889" transform="translate(58.56 35.613)" fill="white">
              <rect width="92.757" height="54.76" stroke="none" fill="white"/>
              <rect x="0.5" y="0.5" width="91.757" height="53.76" fill="white"/>
            </g>
          </g>
        </g>
      </g>
    </StyledSVGIcon>
  );
};